export default "__VITE_ASSET__iNOu6Jv3__"